var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76082 11.6172C7.56882 11.6172 7.37682 11.5442 7.23082 11.3972C6.49282 10.6602 6.08582 9.68019 6.08582 8.63819C6.08582 6.47819 7.84182 4.72119 9.99982 4.72119C11.0378 4.72119 12.0458 5.14019 12.7648 5.87119C13.0548 6.16719 13.0518 6.64119 12.7558 6.93119C12.4608 7.22319 11.9868 7.21819 11.6958 6.92419C11.2568 6.47719 10.6388 6.22119 9.99982 6.22119C8.66882 6.22119 7.58582 7.30519 7.58582 8.63819C7.58582 9.27919 7.83682 9.88319 8.29082 10.3372C8.58382 10.6302 8.58382 11.1042 8.29182 11.3972C8.14482 11.5442 7.95282 11.6172 7.76082 11.6172Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5674 12.4913C10.2124 12.4913 9.89638 12.2373 9.83038 11.8753C9.75638 11.4683 10.0264 11.0773 10.4344 11.0033C11.4144 10.8253 12.1904 10.0473 12.3664 9.0663C12.4404 8.6593 12.8304 8.3913 13.2374 8.4613C13.6454 8.5343 13.9164 8.9243 13.8434 9.3323C13.5564 10.9253 12.2944 12.1893 10.7024 12.4793C10.6574 12.4873 10.6114 12.4913 10.5674 12.4913Z",
    fill: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_880",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.624512H16.0862V14.7226H0V0.624512Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_880)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65441 14.7226C4.49241 14.7226 4.32941 14.6696 4.19141 14.5626C2.50041 13.2346 1.07141 11.2876 0.0614084 8.93364C-0.0205916 8.74364 -0.0205916 8.52964 0.0614084 8.34064C1.08241 5.97664 2.52041 4.01964 4.22041 2.68264C7.68641 -0.0603611 12.3004 -0.0693612 15.8014 2.70264C16.1264 2.95964 16.1814 3.43164 15.9244 3.75664C15.6664 4.07964 15.1964 4.13664 14.8704 3.87864C11.9044 1.53064 8.08341 1.53864 5.14941 3.86064C3.71341 4.99064 2.48041 6.63664 1.57041 8.63864C2.47141 10.6286 3.69341 12.2646 5.11841 13.3826C5.44441 13.6386 5.50041 14.1106 5.24441 14.4356C5.09641 14.6236 4.87641 14.7226 4.65441 14.7226Z",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_278_880",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 14,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71747 4.74121H20V16.6894H6.71747V4.74121Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_278_880)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 16.6894C9.0631 16.6894 8.1311 16.5374 7.2311 16.2384C6.8381 16.1074 6.6251 15.6824 6.7561 15.2894C6.8871 14.8954 7.3101 14.6864 7.7051 14.8144C8.4521 15.0634 9.2241 15.1894 10.0001 15.1894C13.4281 15.1894 16.5611 12.7474 18.4301 8.63642C17.9741 7.63742 17.4431 6.73242 16.8491 5.94242C16.6001 5.61142 16.6661 5.14042 16.9971 4.89142C17.3271 4.64242 17.7981 4.71042 18.0471 5.04042C18.7711 6.00142 19.4071 7.11242 19.9381 8.33842C20.0211 8.52842 20.0211 8.74442 19.9381 8.93342C17.8421 13.7904 14.1271 16.6894 10.0001 16.6894Z",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_278_880",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 18,
    height: 18
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.36356 0.000488281H18.6371V17.2735H1.36356V0.000488281Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_278_880)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11331 17.2733C1.92131 17.2733 1.72931 17.2003 1.58331 17.0533C1.29031 16.7603 1.29031 16.2863 1.58331 15.9933L17.3573 0.219262C17.6503 -0.0737383 18.1243 -0.0737383 18.4173 0.219262C18.7103 0.512262 18.7103 0.987262 18.4173 1.28026L2.64331 17.0533C2.49731 17.2003 2.30531 17.2733 2.11331 17.2733Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.40242bed1bd326711873281c616cbb57.svg";
export { ForwardRef as ReactComponent };